import React, {PureComponent} from 'react';

import * as environment from '../../../modules/environment';

import {Col, Button, Row, Card, CardBody} from 'reactstrap';
import TextSearch from '../../../components/TextSearch'
import * as http from '../../../modules/http';
import LoadingProgress from '../../../components/LoadingProgress';
import {
    admin_update_field,
    admin_hname_insert,
    admin_hname_update
} from '../../../redux/actions/AdminActions';
import Alert from '../../../components/Alert';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import * as TextManager from "../../../modules/languages/TextManager";


class EditHandleNameForm extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            warning: '',
            error: false
        };
    }

    componentDidMount() {
    }

    editValue(store, label, newValue) {
        this.props.dispatch(admin_update_field(store, label, newValue));
    }

    saveStore() {

        const isAdding = (this.props.handleNameInEdit.id === 0);

        //validation
        if (isAdding) {
            if (!this.props.handleNameInEdit.handleName || this.props.handleNameInEdit.handleName === '') {
                this.setState({warning: TextManager.getCurrentTextResource().Text.pleaseSelectName});
                return;
            }
        }

        this.setState({saving: true, error: false, warning: ''});

        const storeData = {
            id: this.props.handleNameInEdit.id,
            handleName: this.props.handleNameInEdit.handleName
        };

        var requestUrl = 'handle_name/update';
        if (isAdding) {
            requestUrl = 'handle_name/new';
        }
        http.postToServer(
            requestUrl,
            storeData,
            (response) => {

                this.setState({saving: false, error: false});

                if (isAdding) {
                    this.props.dispatch(admin_hname_insert(response.data));
                }
                else {
                    this.props.dispatch(admin_hname_update(response.data));
                }

                //this.props.dispatch(fetchUserDataIfNeeded(true));
                this.props.onClose();

            },
            (response) => {
                console.warn('error storing', response);
                this.setState({saving: false, error: true})

            }
        );
    }

    render() {

        const isAdding = this.props.handleNameInEdit.id === 0;

        return (

            <Row>
                <Col md={12}>
                    <Card>
                        <CardBody>
                            <div className='card__title'>

                                {isAdding &&
                                    <h5 className='bold-text'>הוסף שם משווק</h5>
                                }

                                {!isAdding &&
                                    <h5 className='bold-text'>ערוך שם משווק</h5>
                                }

                            </div>
                            <form className='form form--horizontal'>

                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>שם משווק</label>
                                    <div className='form__form-group-field'>
                                        <TextSearch value={this.props.handleNameInEdit.handleName}
                                                    onChange={(value) => this.editValue('handleNameInEdit', 'handleName', value)}/>
                                    </div>
                                </div>

                            </form>

                            {this.state.error &&
                            <Row>
                                <Alert color='danger' className='alert--bordered' icon>
                                    <p><span
                                        className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span>
                                    </p>
                                    <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                                </Alert>
                            </Row>
                            }

                            {this.state.warning !== '' &&
                            <Row>
                                <Alert color='warning' className='alert--bordered' icon>
                                    <p><span
                                        className='bold-text'>{TextManager.getCurrentTextResource().Text.validation}</span> {this.state.warning}
                                    </p>
                                </Alert>
                            </Row>
                            }

                            {!this.state.saving &&
                            <span>
                                        <Button color='primary' size='sm'
                                                onClick={() => this.props.onClose()}>{TextManager.getCurrentTextResource().Text.cancel}</Button>
                                        < Button color='primary' size='sm'
                                                 onClick={() => this.saveStore()}>{TextManager.getCurrentTextResource().Text.save}</Button>
                                    </span>
                            }
                            {
                                this.state.saving &&
                                <LoadingProgress/>
                            }
                        </CardBody>
                    </Card>
                </Col>

            </Row>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        handleNameInEdit: state.admin.handleNameInEdit,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(EditHandleNameForm))